var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.667 19.25V17.4167C14.667 16.4442 14.2806 15.5116 13.5929 14.8239C12.9052 14.1363 11.9725 13.75 11 13.75H5.49956C4.52702 13.75 3.59432 14.1363 2.90663 14.8239C2.21894 15.5116 1.8326 16.4442 1.8326 17.4167V19.25M14.667 2.86727C15.4533 3.07111 16.1497 3.53026 16.6468 4.17266C17.144 4.81506 17.4137 5.60433 17.4137 6.4166C17.4137 7.22887 17.144 8.01815 16.6468 8.66055C16.1497 9.30294 15.4533 9.7621 14.667 9.96594M20.1674 19.2499V17.4166C20.1668 16.6041 19.8964 15.8149 19.3986 15.1728C18.9008 14.5308 18.2039 14.0722 17.4172 13.8691M11.9167 6.41667C11.9167 8.44171 10.275 10.0833 8.24978 10.0833C6.22457 10.0833 4.58282 8.44171 4.58282 6.41667C4.58282 4.39162 6.22457 2.75 8.24978 2.75C10.275 2.75 11.9167 4.39162 11.9167 6.41667Z",
    stroke: "#182553",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.12356b075f5c867a701b2a6d31d0df01.svg";
export { ForwardRef as ReactComponent };